import { render, staticRenderFns } from "./AvalancheBox.vue?vue&type=template&id=73050e66&scoped=true"
import script from "./AvalancheBox.vue?vue&type=script&lang=js"
export * from "./AvalancheBox.vue?vue&type=script&lang=js"
import style0 from "./AvalancheBox.vue?vue&type=style&index=0&id=73050e66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73050e66",
  null
  
)

export default component.exports